var moduleMap = {
	"./Donations": () => {
		return Promise.all([__webpack_require__.e(542), __webpack_require__.e(158), __webpack_require__.e(416), __webpack_require__.e(991), __webpack_require__.e(481), __webpack_require__.e(334), __webpack_require__.e(63), __webpack_require__.e(678)]).then(() => (() => ((__webpack_require__(4259)))));
	},
	"./DonationDetails": () => {
		return Promise.all([__webpack_require__.e(542), __webpack_require__.e(158), __webpack_require__.e(416), __webpack_require__.e(991), __webpack_require__.e(481), __webpack_require__.e(334), __webpack_require__.e(833), __webpack_require__.e(171), __webpack_require__.e(63), __webpack_require__.e(729)]).then(() => (() => ((__webpack_require__(1729)))));
	},
	"./AllDonates": () => {
		return Promise.all([__webpack_require__.e(542), __webpack_require__.e(158), __webpack_require__.e(416), __webpack_require__.e(991), __webpack_require__.e(481), __webpack_require__.e(334), __webpack_require__.e(14)]).then(() => (() => ((__webpack_require__(3460)))));
	},
	"./DonationCart": () => {
		return Promise.all([__webpack_require__.e(416), __webpack_require__.e(991), __webpack_require__.e(334), __webpack_require__.e(833), __webpack_require__.e(33), __webpack_require__.e(854)]).then(() => (() => ((__webpack_require__(4770)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});